// import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaCalendarAlt } from "react-icons/fa";
import "./FeaturedProjects.css";

const ProjectCard = ({ project }) => {
  return (
    <div className="project-card">
      <img src={project.image} alt={project.title} className="project-image" />

      <div className="project-overlay">
        <div className="project-category">{project.category}</div>

        <div className="project-content">
          <h3>{project.title}</h3>

          <div className="project-info">
            <span>
              <FaMapMarkerAlt />
              {project.location}
            </span>

            <span>
              <FaCalendarAlt />
              {project.year}
            </span>
          </div>

          <div className="project-specs">
            <span>{project.surface}</span>

            <span>{project.area}</span>
          </div>

          {/* <Link
            to={project.route}
            className="project-btn"
          >
            View Project →
          </Link> */}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
